export default __webpack_public_path__ + "static/media/report_grant.db40ff04.svg";